import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../../UI/form/MyButton'
import MyModal from '../../../../../UI/modal/MyModal'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SupplyBillDeliveryForm from './SupplyBillDeliveryForm';

const SupplyBillDeliveryButton = ({ supplyBillId, billDelivery }) => {

    const [open, setOpen] = useState(false)

  return (
     <>
        <MyButton
            size='smExtra'
            onClick={e => setOpen(true)}
        >
            {
                // <AddIcon />
                billDelivery ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={billDelivery ? 'Редагувати доставку' : 'Додати доставку'}
            // header={'Додати доставку'}
            disableClickOutside={true}
            content={
                <SupplyBillDeliveryForm
                    supplyBillId={supplyBillId}
                    billDeliveryBd={billDelivery}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default SupplyBillDeliveryButton